import React from "react";
import adtest from "./adtest"

class HorizontalAdComponent extends React.Component {
  componentDidMount() {
    // this.interval = setInterval(
    //   () => this.setState({ time: Date.now() }),
    //   Math.floor(30000+Math.random()*(60000+1-30000))
    // );
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // }

  // componentDidUpdate(prevState) {
  //   if (this.state.time !== prevState.time) {
  //     (window.adsbygoogle = window.adsbygoogle || []).push({});
  //   }
  // }

  render() {
    // const adWidth = this.props.viewportWidth;
    // console.log("adWidth: " + adWidth);

    return (
      <div
      // style={{
      //   display: "block",
      //   padding: "0 12px 12px 0",
      // }}
      >
        {/* <p>rerendered {this.state.time}</p> */}
        <ins
          className="adsbygoogle"
          // key={Math.random()}
          style={{
            maxHeight: "200px",
            display: "block",
            textAlign: "center",
            padding: "8px 0 8px 0",
            // maxWidth: adWidth,
          }}
          data-ad-client={this.props.dataAdClient}
          data-ad-slot={this.props.dataAdSlot}
          data-ad-format="horizontal"
          data-full-width-responsive="false"
          data-adtest={adtest}
        />
      </div>
    );
  }
}

export default HorizontalAdComponent;


// WEBPACK FOOTER //
// ./src/components/ads/HorizontalAdComponent.js